import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MessageCrudService} from "@evomatik/evk-common";
import { TipoExpedienteEnum } from '../../../enums/tipo-expediente-enum';
import { ExpedientesPageService } from '../../../services/expedientes-page.service';

@Component({
    selector: 'lib-folio-dialog',
    templateUrl: './folio-dialog.component.html',
    styleUrls: ['./folio-dialog.component.css'],
    providers: [ExpedientesPageService],
    encapsulation: ViewEncapsulation.None
})
export class FolioDialogComponent implements OnInit {
    folio = "";
    verificando: boolean = true;
    expedientesConMismoNombre = -1;
    strFolios: String;

    constructor(
        public messageCrudService: MessageCrudService,
        public dialogRef: MatDialogRef<FolioDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public pageService: ExpedientesPageService,
    ) {
        if (this.data.folio) {
            this.folio = this.data.folio;
        }
        if (this.data.expediente) {

            const seccionPersona = this.data.expediente.secciones.find((seccion) => {
                return seccion.origen == "personaDesaparecida";
            });
            if(seccionPersona){
                this.pageService.addFilter("tipoExpediente", TipoExpedienteEnum.VICTIMAS_DESAPARECIDAS);
                this.pageService.addFilter("nombre", seccionPersona.propiedades.datosPersonaDesaparecida.nombre);
                this.pageService.addFilter("primerApellido", seccionPersona.propiedades.datosPersonaDesaparecida.primerApellido);
                this.pageService.addFilter("segundoApellido", seccionPersona.propiedades.datosPersonaDesaparecida.segundoApellido);
            }
        }


    }

    ngOnInit(): void {
        this.pageService.page().subscribe((result) =>{
            if(result && result["data"]){
                this.expedientesConMismoNombre = result["data"].totalElements > 1 ? result["data"].totalElements-1 : 0;
                if (this.expedientesConMismoNombre > 0){
                    this.strFolios = "";
                    for (let i = 0; i < result["data"]["content"].length; i++){
                        const e = result["data"]["content"][i];
                        if (this.data.expediente.id !== e.id){
                            this.strFolios += e.folio ? e.folio : e.folioProvisional;
                            if ((i + 1) < result["data"]["content"].length) {
                                this.strFolios += ", ";
                            }
                        }
                    }
                }
            }
            this.verificando = false;
        });
    }

    save() {
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de asociar este folio con el expediente? ',
            goonbtn: 'Guardar'
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.dialogRef.close({folio: this.folio});
            confirmDialog.close();
        });
    }
}
